export const API_BASE_URL = process.env.VUE_APP_API_BASE_URL || 'https://api.nyenyeziaforex.com';

export function apiUrl(path) {
  const normalizedPath = path.startsWith('/') ? path : `/${path}`;
  return `${API_BASE_URL}${normalizedPath}`;
}
